import React, { Component } from 'react';
import { I18n } from 'react-i18next';

class ResultsNotes extends Component {
  state = {
    content: this.props.expanded,
  };

  toggleContent = () => {
    const { content } = this.state;
    this.setState({ content: !content });
  };

  render() {
    const content = (
      <div className={this.state.content ? 'content is-open' : 'content'}>
        {this.props.equipment.application_notes.map((element) => {
          return <p key={element.id}>{element['note_index'] + '. ' + element.text}</p>;
        })}
      </div>
    );

    return (
      <I18n ns="translations">
        {(t) => (
          <section className="results-notes">
            <div
              onClick={this.toggleContent}
              className={this.state.content ? 'title tab-name active' : 'title tab-name'}
            >
              {t('result_notes.notes')}
            </div>
            {content}
          </section>
        )}
      </I18n>
    );
  }
}

export default ResultsNotes;



// WEBPACK FOOTER //
// ./src/components/results/resultsNotes.js